const Main = () => import('./views/Main');

export default [
    { path: '', name: 'DashboardMain', component: Main, meta: { title: 'Seja bem vindo!' } },
];
